<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">开单打卡&nbsp;/&nbsp;</span>
      </div>
      <div>打卡异常</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header space-between">
            <div class="flex-row">
              <el-select v-model="query.auditStatus" placeholder="审核状态" filterable @change="selectChange">
                <el-option label="全部状态" value></el-option>
                <el-option label="待审核" value="wait"></el-option>
                <el-option label="通过" value="pass"></el-option>
                <el-option label="拒绝" value="refuse"></el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="exceptionsApply" v-perm="{key:'attendancePunch', value: 'attendancePunch:apply'}">打卡异常申请</el-button>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="staffName" label="店员姓名"></el-table-column>
              <el-table-column prop="attendanceTypeCn" label="异常类型" width="auto">
                <template slot-scope="scope">
                  {{scope.row.attendanceTypeCn}}{{scope.row.abnormalTypeCn}}
                </template>
              </el-table-column>
              <el-table-column prop="auditStatusCn" width="auto" label="状态"></el-table-column>
              <el-table-column prop="attendanceDate" label="打卡日期" width="170px">
                <template slot-scope="scope">{{ formatDay(scope.row.attendanceDate) }}</template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-link type="primary" @click="details(scope.row)">查看详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <detail ref="detailForm"></detail>
    <audit ref="auditForm" @change="totalCounts"></audit>
    <exceptionsApply ref="applyForm" @change="totalCounts"></exceptionsApply>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detail from "./detail.vue";
import audit from "./audit.vue";
import exceptionsApply from "./exceptionsApply.vue";
export default {
  data() {
    return {
      url: this.$url.attendanceApply.list,
      query: {
        auditStatus: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      list: []
    };
  },
  mixins: [minxin],
  components: {detail,audit,exceptionsApply},
  computed: {},

  created() {
    this.totalCounts();
  },

  methods: {
    details (row) {
      console.log(row);
      let isSuperManage = JSON.parse(localStorage.getItem("shopInfo")).superManage;
      if (isSuperManage && row.auditStatus == "wait") return this.$refs["auditForm"].$emit("set", row);
      this.$refs["detailForm"].$emit("set", row);
    },
    exceptionsApply () {
      this.$refs["applyForm"].$emit("set", true);
    },
    back() {
      this.$router.push("/dataList/attendancePunch");
    },
    auditBack () {
      this.getData();
    },
    // auditForm
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.$url.attendanceApply.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    
    padding: 16px;
    display: flex;
  }
}
</style>